<template>

  <div class="product-add pb50" v-loading="loading">

     <el-form size="small" :model="form" ref="form" label-width="150px">
       <div class="common-form">详情</div>
        <el-form-item label="头像" prop="image_url"><img v-img-url="form.image_url" alt="" width="60" /></el-form-item>
        <el-form-item label="姓名" prop="name">{{form.name}}</el-form-item>
        <el-form-item label="手机" prop="mobile"><el-input v-model="phone" placeholder="请输入手机号 " style="width: 20%" @blur="changePhone"></el-input></el-form-item>
        <el-form-item label="微信" prop="wechat">{{form.wechat}}</el-form-item>
        <el-form-item label="生日" prop="birthday">{{form.birthday}}</el-form-item>
        <el-form-item label="性别" prop="birthday">{{form.sexname}}</el-form-item>
        <el-form-item label="来源" prop="type">{{form.source}}</el-form-item>
        <el-form-item label="主播id" prop="anchor_data_id">{{form.anchor_data_id}}</el-form-item>
        <el-form-item label="主播用户id" prop="anchor_user_id">{{form.anchor_user_id}}</el-form-item>
        <el-form-item label="已开播天数" prop="broadcast_num">{{form.broadcast_num}}天</el-form-item>
        <el-form-item label="带货类型" prop="broadcast_type">{{form.broadcast_type}}</el-form-item>
        <el-form-item label="期望带货类型" prop="hope_bring_type">{{form.hope_bring_type}}</el-form-item>
        <el-form-item label="期望单价" prop="hope_unit_price">{{form.hope_unit_price}}</el-form-item>
        <el-form-item label="是否开启橱窗" prop="is_open_window">{{form.is_open_window}}</el-form-item>
        <el-form-item label="个人是否有运营团队" prop="team">{{form.isTeam}}</el-form-item>
         <el-form-item label="账号是否能自行挂链接" prop="link">{{form.link}}</el-form-item>
     </el-form>
  </div>
</template>

<script>
import AnchorApi from '@/api/anchor.js';

export default {
  components: {

  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      phone:'',
      /*form表单数据*/
      form: {
      },
    };
  },
  created() {

    this.getDetail();

  },

  methods: {

    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      const params = self.$route.query.anchor_id;
      AnchorApi.toEditAnchor({anchor_id: params},true).then(res => {
         
          self.form = res.data;
          self.form.sexname =self.form.sex? "男":"女";
          self.form.source = self.form.type=='douyin'?"抖音":"其他";
          self.form.openwindow= self.form.is_open_window?"是":"否";
          self.form.team= self.form.isteam?"是":"否";
           self.form.link= self.form.islink?"是":"否";
           self.phone = self.form.mobile;
          self.loading = false;
        })
        .catch(error => {});
    },

    changePhone(){
      let self = this;
      const params = self.$route.query.anchor_id;

      AnchorApi.editAnchorPhone({anchor_id:params,phone:self.phone},true).then(res=>{
        if(res.code == 1){
          self.$message({
            message: res.msg,
            type: 'success'
          });
        }
      }).catch(error => {});
    }
  },

};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/anchor/anchor/detail.vue